import { Reveal } from "../shared/Reveal";
import { MANIFESTO } from "../../data/homeContent";

// Numbered manifesto chapters — the brand's core message.
export default function Manifesto() {
  return (
    <section className="bg-primary text-primary-foreground py-24 md:py-36" data-testid="manifesto-section">
      <div className="container-psv">
        <Reveal>
          <span className="eyebrow mb-10 block text-accent">{MANIFESTO.eyebrow}</span>
        </Reveal>
        <div className="max-w-5xl">
          {MANIFESTO.lines.map((line, i) => (
            <Reveal key={i} delay={i * 0.08} className="flex items-baseline gap-5 md:gap-10 py-3 md:py-5 border-b border-primary-foreground/15">
              <span className="font-sans text-sm md:text-base text-accent tabular-nums shrink-0 pt-2">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-serif text-3xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight">
                {line}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
